import React from "react";
import ModuleGroupsView from "./ModuleGroupsView";

import { createAppQueryClient } from "../application/queryClients";
import { AppQueryClientProvider } from "../application/AppQueryClientProvider";

const ModuleGroupsApplication = () => {
  // Create a client
  const queryClient = createAppQueryClient({
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    retry: false,
    staleTime: Infinity,
  });

  return (
    <AppQueryClientProvider client={queryClient}>
      <ModuleGroupsView />
    </AppQueryClientProvider>
  );
};

export default ModuleGroupsApplication;
